import { LinearProgress } from '@llt-frontend/react-material-progress';
import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import useLoadingContext from '../../hooks/context/use-loading-context';

//

function PageLoadingIndicator({ children, className, show, ...forwardedProps }) {
  const { loading } = useLoadingContext();

  //
  // Render

  if (show === false || (!loading && !show)) {
    return null;
  }

  return (
    <LinearProgress
      {...forwardedProps}
      className={classNames('page-loading-indicator', className)}
    />
  );
}

PageLoadingIndicator.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  show: PropTypes.bool,
};

// Exports
// -------

export default PageLoadingIndicator;
